import { createFileRoute } from '@tanstack/react-router';
import IndexPage from '@/pages/static/IndexPage';

export const Route = createFileRoute('/')({
  component: IndexPage,
});
